import { h, Host } from "@stencil/core";
export class Chat {
    constructor() {
        this.typing = undefined;
    }
    el;
    componentDidLoad() {
        // No need for manual scroll management
    }
    render() {
        return (h(Host, { key: '2b644a0d490bf1a76c55f009b0462f6321ab30c9' }, h("div", { key: '5bc9f47f331db28fe7a87512f29c61eba558d793', id: "chat-container" }, h("div", { key: '4cba481181995ee8c7cc037bc9e2ed9c969dccd5', id: "items", role: "list", "aria-live": "polite" }, h("slot", { key: '520be918552bf5b0168a586e0e0a7daed640b101' }), " ", this.typing && h("ux-chat-typing-indicator", { key: '33239f18ff856e449871cb4e42017494f7a15feb', text: this.typing }))), h("div", { key: '9720bc1a79ec6e2e86c957595f667fbd16dbb92c', id: "chat-bar" }, h("slot", { key: 'ccbcf82aa04062925653ae03bd39980776778457', name: "bar" }), " ")));
    }
    static get is() { return "ux-chat"; }
    static get encapsulation() { return "shadow"; }
    static get originalStyleUrls() {
        return {
            "$": ["chat.scss"]
        };
    }
    static get styleUrls() {
        return {
            "$": ["chat.css"]
        };
    }
    static get properties() {
        return {
            "typing": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string | undefined",
                    "references": {}
                },
                "required": false,
                "optional": true,
                "docs": {
                    "tags": [],
                    "text": "Indicates if chat partner is currently typing."
                },
                "attribute": "typing",
                "reflect": false
            }
        };
    }
    static get elementRef() { return "el"; }
}
//# sourceMappingURL=chat.js.map
